import { memo } from "react";

import Skeleton from "@/components/ui/Skeleton";

/**
 * Full-page loading skeleton shown while a lazy page chunk is loading.
 * Used as the <Suspense fallback> in AppShell.
 */
const PageLoader = memo(function PageLoader() {
  return (
    <div
      className="animate-fade-in space-y-6 p-6"
      aria-busy
      aria-label="Loading page"
    >
      {/* Header row */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-9 w-24" />
      </div>

      {/* Stats row */}
      <div className="grid grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="card space-y-3 p-4">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-8 w-16" />
          </div>
        ))}
      </div>

      {/* Main content */}
      <div className="card space-y-3 p-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    </div>
  );
});

export default PageLoader;
